(function () {
    'use strict';

    angular.module('app.dashboard', ['FileManagerApp']);
})();